import { useState } from "react";
import { Link } from "react-router-dom";
import FAQItem from "./FAQItem";

interface FAQ {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  title?: string;
  data: FAQ[];
  link: string;
}

export default function FAQSection({
  title = "Adivaa Protection FAQs",
  data,
  link
}: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="tw-bg-white tw-pt-20 tw-pb-24">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-6">
        <h2 
          className="tw-text-4xl md:tw-text-5xl tw-font-bold tw-text-center tw-mb-16 tw-text-black"
          style={{ fontFamily: "'PP Mori', sans-serif" }}
        >
          {title}
        </h2>
        <div>
          {data.map((faq, index) => (
            <FAQItem
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
        <div className="tw-mt-20 tw-text-center">
          <Link
            to={link}
            className="tw-text-lg tw-font-semibold hover:tw-underline tw-text-black"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Terms & Conditions
          </Link>
        </div>
      </div>
    </section>
  );
}